import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal",
  id: "threshold_config_modal",
  tabindex: "-1",
  role: "dialog",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document",
  style: {"min-width":"600px","max-width":"900px"}
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-info",
  role: "alert"
}
const _hoisted_8 = {
  class: "alert alert-danger alert-dismissible show",
  role: "alert"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "form-group mb-3" }
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = { class: "form-group mb-3" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = { class: "form-group mb-3 double-row" }
const _hoisted_15 = ["title"]
const _hoisted_16 = { class: "input-group-text" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = { class: "form-group mb-3" }
const _hoisted_19 = { class: "input-group" }
const _hoisted_20 = { class: "form-group mb-3" }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = { id: "sensorNameSuggestions" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "border p-2 mb-3" }
const _hoisted_25 = { class: "form-group row g-2" }
const _hoisted_26 = { class: "input-group col-8" }
const _hoisted_27 = {
  class: "input-group col-4",
  title: "Silent until the reference sensor has this much history"
}
const _hoisted_28 = { class: "border p-2 mb-3" }
const _hoisted_29 = { class: "list-group-flush p-0 mb-2" }
const _hoisted_30 = { class: "ms-1" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "form-group row g-2" }
const _hoisted_33 = { class: "input-group col" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "input-group col" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { id: "tagInSuggestions" }
const _hoisted_38 = ["value"]
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "border p-2 mb-3" }
const _hoisted_41 = { class: "list-group-flush p-0 mb-2" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "form-group row g-2" }
const _hoisted_44 = { class: "input-group col" }
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "input-group col" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { id: "tagLikeSuggestions" }
const _hoisted_49 = ["value"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "form-group mb-3" }
const _hoisted_52 = { class: "form-check" }
const _hoisted_53 = { class: "modal-footer" }
const _hoisted_54 = {
  key: 0,
  class: "modal-dialog"
}
const _hoisted_55 = { class: "modal-content" }
const _hoisted_56 = { class: "modal-footer alert-warning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.managed ? "View" : "Configure") + " " + _toDisplayString(_ctx.Name || "New Threshold"), 1),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedThreshold && _ctx.clearSelectedThreshold(...args)))
          }, [...(_cache[25] || (_cache[25] = [
            _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.managed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_vue_feather, {
                  type: "lock",
                  size: "14"
                }),
                _cache[26] || (_cache[26] = _createTextVNode(" This threshold is managed, so you can see it but not edit it. Please contact the blades team for changes. ", -1))
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_8, [
            _cache[28] || (_cache[28] = _createElementVNode("strong", null, "Error:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.errorMessage) + " ", 1),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "alert",
              "aria-label": "Close",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.errorMessage = ''))
            }, [...(_cache[27] || (_cache[27] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ], 512), [
            [_vShow, _ctx.errorMessage]
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("fieldset", { disabled: _ctx.managed }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[29] || (_cache[29] = _createElementVNode("div", { class: "input-group-text" }, "Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.Name) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.Name]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[30] || (_cache[30] = _createElementVNode("div", { class: "input-group-text" }, "Description", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    rows: "2",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.Description) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.Description]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  class: "input-group",
                  title: _ctx.isRelative ? 'Multiplier of the reference sensor; 1.0 = at the reference' : ''
                }, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.isRelative ? "Multiplier" : "Value"), 1),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "number",
                    step: "any",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.Value) = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.Value,
                      void 0,
                      { number: true }
                    ]
                  ])
                ], 8, _hoisted_15),
                _createElementVNode("div", _hoisted_17, [
                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "input-group-text" }, "Severity", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.Severity) = $event))
                  }, [...(_cache[31] || (_cache[31] = [
                    _createElementVNode("option", { value: null }, "None", -1),
                    _createElementVNode("option", { value: "warning" }, "Warning", -1),
                    _createElementVNode("option", { value: "high" }, "High", -1),
                    _createElementVNode("option", { value: "critical" }, "Critical", -1)
                  ]))], 512), [
                    [_vModelSelect, _ctx.Severity]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[33] || (_cache[33] = _createElementVNode("div", { class: "input-group-text" }, "Diagnosis Dashboard UID", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    placeholder: "Optional — uid from the Grafana dashboard URL (/d/<uid>/...)",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.DashboardUID) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.DashboardUID]
                  ])
                ])
              ]),
              _cache[48] || (_cache[48] = _createElementVNode("div", { class: "text h5" }, "Selector", -1)),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "input-group-text" }, "Sensor Name (LIKE)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    list: "sensorNameSuggestions",
                    placeholder: "e.g. %temperature%",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sensorNameLike) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.sensorNameLike]
                  ]),
                  _createElementVNode("datalist", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sensorNameSuggestions, (name) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: name,
                        value: name
                      }, null, 8, _hoisted_23))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "text h6" }, "Reference (optional, makes the threshold relative)", -1)),
                _cache[38] || (_cache[38] = _createElementVNode("div", { class: "form-text mb-2" }, " Compare each matched sensor against the sensor with the same tags whose name is the matched name plus this suffix, e.g. a waterline. Value then becomes a multiplier of that reference. The suffix is appended exactly as typed, so include its leading space or separator. ", -1)),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "input-group-text" }, "Name suffix", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      type: "text",
                      placeholder: "e.g. ' - to-date 99.99th percentile waterline' (with the leading space)",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.referenceSuffix) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.referenceSuffix]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "input-group-text" }, "Min history (days)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      type: "number",
                      min: "0",
                      step: "1",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.referenceMinDays) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.referenceMinDays,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[42] || (_cache[42] = _createElementVNode("div", { class: "text h6" }, "Tags In (exact match)", -1)),
                _createElementVNode("ul", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagsIn, (values, key) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "list-group-item d-flex justify-content-between align-items-center p-1",
                      key: key
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, _toDisplayString(key) + ":", 1),
                        _createElementVNode("span", _hoisted_30, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values, (val) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "badge bg-secondary me-1 px-2 py-1",
                              key: val
                            }, [
                              _createTextVNode(_toDisplayString(val) + " ", 1),
                              _createElementVNode("span", {
                                class: "ms-1",
                                role: "button",
                                onClick: ($event: any) => (_ctx.removeTagInValue(key as string, val))
                              }, " × ", 8, _hoisted_31)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "input-group-text" }, "Tag", -1)),
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newTagInKey) = $event)),
                      onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.newTagInValue = ''))
                    }, [
                      _cache[39] || (_cache[39] = _createElementVNode("option", {
                        value: "",
                        disabled: ""
                      }, "Select tag", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.sensorTagOptions).sort(), (key) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: key,
                          value: key
                        }, _toDisplayString(key), 9, _hoisted_34))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.newTagInKey]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _cache[41] || (_cache[41] = _createElementVNode("div", { class: "input-group-text" }, "Value", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      type: "text",
                      list: "tagInSuggestions",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newTagInValue) = $event)),
                      disabled: !_ctx.newTagInKey,
                      placeholder: "Type or select..."
                    }, null, 8, _hoisted_36), [
                      [_vModelText, _ctx.newTagInValue]
                    ]),
                    _createElementVNode("datalist", _hoisted_37, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagInValueSuggestions, (s) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: s,
                          value: s
                        }, null, 8, _hoisted_38))
                      }), 128))
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-outline-success",
                      type: "button",
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.addTagIn && _ctx.addTagIn(...args))),
                      disabled: !_ctx.newTagInValue
                    }, [
                      _createVNode(_component_vue_feather, { type: "plus" })
                    ], 8, _hoisted_39)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "text h6" }, "Tags Like (pattern match)", -1)),
                _createElementVNode("ul", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagsLike, (pattern, key) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "list-group-item d-flex justify-content-between align-items-center p-1",
                      key: key
                    }, [
                      _createElementVNode("span", null, [
                        _createElementVNode("strong", null, _toDisplayString(key) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(pattern), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-outline-danger",
                        onClick: ($event: any) => (_ctx.removeTagLike(key as string))
                      }, [
                        _createVNode(_component_vue_feather, { type: "trash" })
                      ], 8, _hoisted_42)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _cache[44] || (_cache[44] = _createElementVNode("div", { class: "input-group-text" }, "Tag", -1)),
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newTagLikeKey) = $event)),
                      onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.newTagLikeValue = ''))
                    }, [
                      _cache[43] || (_cache[43] = _createElementVNode("option", {
                        value: "",
                        disabled: ""
                      }, "Select tag", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTagLikeKeys, (key) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: key,
                          value: key
                        }, _toDisplayString(key), 9, _hoisted_45))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.newTagLikeKey]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "input-group-text" }, "Pattern", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      type: "text",
                      list: "tagLikeSuggestions",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newTagLikeValue) = $event)),
                      disabled: !_ctx.newTagLikeKey,
                      placeholder: "e.g. %pattern%"
                    }, null, 8, _hoisted_47), [
                      [_vModelText, _ctx.newTagLikeValue]
                    ]),
                    _createElementVNode("datalist", _hoisted_48, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagLikeValueSuggestions, (s) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: s,
                          value: s
                        }, null, 8, _hoisted_49))
                      }), 128))
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-outline-success",
                      type: "button",
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.addTagLike && _ctx.addTagLike(...args))),
                      disabled: !_ctx.newTagLikeValue
                    }, [
                      _createVNode(_component_vue_feather, { type: "plus" })
                    ], 8, _hoisted_50)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    id: "enabledCheck",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.Enabled) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.Enabled]
                  ]),
                  _cache[47] || (_cache[47] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "enabledCheck"
                  }, " Enabled ", -1))
                ])
              ])
            ], 8, _hoisted_9)
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_53, [
          (_ctx.selected_threshold.ThresholdID && !_ctx.managed)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-danger",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
              }, " Delete "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-dismiss": "modal",
            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedThreshold && _ctx.clearSelectedThreshold(...args)))
          }, " Close "),
          (!_ctx.managed)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.saveThreshold && _ctx.saveThreshold(...args)))
              }, "Save changes"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showConfirmDeleteDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _cache[49] || (_cache[49] = _createElementVNode("div", { class: "modal-body alert-warning" }, [
              _createElementVNode("div", { class: "" }, [
                _createElementVNode("span", null, [
                  _createElementVNode("p", null, "Are you sure you want to delete this threshold?")
                ])
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger",
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.callDeleteThreshold && _ctx.callDeleteThreshold(...args)))
              }, "Delete"),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-dismiss": "modal",
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
              }, "Close")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}